/* @flow */

import * as React from 'react';

import {colors} from 'shells/colors';
import {DynamicButtonContent} from 'shells/dynamic-button-content';
import {AiSparkleNewIcon} from 'shells/icon';
import {StackLegacy} from 'shells/layout';

type Props = {|
    buttonText: string | React.Node,
    buttonRef: any,
|};

export function AiButtonContent(props: Props) {
    const {buttonText, buttonRef} = props;

    const ButtonContent = (contentProps: {icon: React.Node}) => (
        <StackLegacy spacing={8} alignCenter={true} isHorizontal={true}>
            <div className='flex align-center'>{contentProps.icon}</div>
            <div>{buttonText}</div>
        </StackLegacy>
    );

    return (
        <DynamicButtonContent
            buttonRef={buttonRef}
            defaultContent={
                <ButtonContent
                    icon={<AiSparkleNewIcon size={15} wrapWithDiv={false} fill={colors.white} />}
                />
            }
            hoverContent={
                <ButtonContent
                    icon={<AiSparkleNewIcon size={15} wrapWithDiv={false} fill={colors.white} />}
                />
            }
        />
    );
}
